import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'

const gridFiltersConfig: any = {
    OBJRANGEFILTER: { prop: null, param: 'OBJRANGEFILTER', url_param: false },
    PERRANGEFILTER: { prop: null, param: 'PERRANGEFILTER', url_param: false },
}

const initialState = {
    loadIx2076ListStatus: 'idle',
    loadIx2076ListError: undefined as any,
    loadIx2076ListLastArgs: undefined as any,
    loadIx2076Status: 'idle',
    loadIx2076Error: undefined as any,
    saveIx2076Status: 'idle',
    saveIx2076Error: undefined as any,
    deleteIx2076Status: 'idle',
    deleteIx2076Error: undefined as any,

    ix2076List: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    objectFilterData: {
        objectRange:  null as any,
        objectRangeValue: null as any,
        usersData: [] as any,
        activeButtonId: null,
        userteamId: null,
        lookupName: '' as string,
        isChecked: false as boolean,
        teamShortName: null as any,
        lookupsValue: null as any
    },
    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadIx2076List = createAsyncThunk('ix2076Slice/loadIx2076List', async ({ gridFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().ix2076Slice.loadIx2076ListLastArgs
    if (_.isEqual(lastArgs, { gridFilters }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/xsp_GetPerOP/?OBJRANGE=${gridFilters.lookupValues.OBJRANGEFILTER?.value || 0}&PERRANGE=${gridFilters.values.PERRANGEFILTER || ''}&PARTNERID=0`, undefined, gridFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { gridFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIx2076ListStatus } = getState().ix2076Slice
        return loadIx2076ListStatus !== 'pending'
    }
})

export const loadIx2076 = createAsyncThunk('ix2076Slice/loadIx2076', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ix2076/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIx2076Status } = getState().ix2076Slice
        return loadIx2076Status !== 'pending'
    }
})

export const saveIx2076 = createAsyncThunk('ix2076Slice/saveIx2076', async ({ ix2076 }: any, { rejectWithValue }: any) => {
    let promises = []
    if (ix2076?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/ix2076/${ ix2076?.HDR_ID }/`,
            prepareData(ix2076),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/ix2076/`,
            prepareData(ix2076),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveIx2076Status } = getState().ix2076Slice
        return saveIx2076Status !== 'pending'
    }
})

export const deleteIx2076 = createAsyncThunk('ix2076Slice/deleteIx2076', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/ix2076/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteIx2076Status } = getState().ix2076Slice
        return deleteIx2076Status !== 'pending'
    }
})

const Ix2076Slice = createSlice({
    name: 'ix2076Slice',
    initialState,
    reducers: {
        resetloadIx2076ListError: (state) => {
            state.loadIx2076ListError = undefined
        },
        resetloadIx2076: (state) => {
            state.formItem = undefined
            state.loadIx2076Error = undefined
        },
        resetloadIx2076Error: (state) => {
            state.loadIx2076Error = undefined
        },
        resetsaveIx2076: (state) => {
            state.formItem = undefined
            state.saveIx2076Error = undefined
        },
        resetsaveIx2076Error: (state) => {
            state.saveIx2076Error = undefined
        },
        resetdeleteIx2076Error: (state) => {
            state.deleteIx2076Error = undefined
        },
        removeFromIx2076ListById: (state, action) => {
            state.ix2076List = state.ix2076List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromIx2076ListByIds: (state, action) => {
            state.ix2076List = state.ix2076List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setObjectFilterData: (state, action) => {
            state.objectFilterData = {...state.objectFilterData, ...action.payload}
        },
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.ix2076List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadIx2076ListStatus = 'preloaded'
            state.loadIx2076ListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.ix2076List = []
            state.loadIx2076ListStatus = 'idle'
            state.loadIx2076ListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadIx2076List.pending, (state) => {
            state.loadIx2076ListStatus = 'pending'
            state.loadIx2076ListError = undefined
        })
        builder.addCase(loadIx2076List.fulfilled, (state, action) => {
            state.loadIx2076ListStatus = 'idle'

            if (!action.payload) { return }

            state.loadIx2076ListLastArgs = action.payload.args

            {
                state.ix2076List = action.payload.data

            }
        })
        builder.addCase(loadIx2076List.rejected, (state, action) => {
            state.loadIx2076ListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIx2076ListError = action.error.message
            } else {
                state.loadIx2076ListError = action.payload
            }
        })

        builder.addCase(loadIx2076.pending, (state) => {
            state.loadIx2076Status = 'pending'
            state.loadIx2076Error = undefined
        })
        builder.addCase(loadIx2076.fulfilled, (state, action) => {
            state.loadIx2076Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ix2076List.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ix2076List.push(newItem) }
                else { state.ix2076List[i] = { ...state.ix2076List[i], ...newItem } }
            }
        })
        builder.addCase(loadIx2076.rejected, (state, action) => {
            state.loadIx2076Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIx2076Error = action.error.message
            } else {
                state.loadIx2076Error = action.payload
            }
        })

        builder.addCase(saveIx2076.pending, (state) => {
            state.saveIx2076Status = 'pending'
            state.saveIx2076Error = undefined
        })
        builder.addCase(saveIx2076.fulfilled, (state, action) => {
            state.saveIx2076Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ix2076List.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ix2076List.push(newItem) }
                else { state.ix2076List[i] = { ...state.ix2076List[i], ...newItem } }
            }
        })
        builder.addCase(saveIx2076.rejected, (state, action) => {
            state.saveIx2076Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveIx2076Error = action.error.message
            } else {
                state.saveIx2076Error = action.payload
            }
        })

        builder.addCase(deleteIx2076.pending, (state) => {
            state.deleteIx2076Status = 'pending'
            state.deleteIx2076Error = undefined
        })
        builder.addCase(deleteIx2076.fulfilled, (state, action) => {
            state.deleteIx2076Status = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.ix2076List = state.ix2076List.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.ix2076List = state.ix2076List.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteIx2076.rejected, (state, action) => {
            state.deleteIx2076Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteIx2076Error = action.error.message
            } else {
                state.deleteIx2076Error = action.payload
            }
        })

    }
})

export const {
    resetloadIx2076ListError,
    resetloadIx2076,
    resetloadIx2076Error,
    resetsaveIx2076,
    resetsaveIx2076Error,
    resetdeleteIx2076Error,
    removeFromIx2076ListById,
    removeFromIx2076ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setObjectFilterData,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Ix2076Slice.actions
export default Ix2076Slice.reducer
